export default class SortingModel {
    fieldName: string;
    isDescendingDirection: boolean;
}